export class Captcha {
  challenge_ts: string;
  error_codes: string[];
  hostname: string;
  success: boolean;
}
